import React, { useEffect, useState } from 'react';

const FlashMessage = ({ 
  message, 
  type = 'info', 
  duration = 3000, 
  onComplete,
  position = 'center'
}) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    const showMs = Math.max(duration, 600);
    const exitTimer = setTimeout(() => {
      setIsAnimating(true);
    }, showMs - 500);
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
      if (onComplete) onComplete();
    }, showMs);

    return () => {
      clearTimeout(exitTimer);
      clearTimeout(hideTimer);
    };
  }, [duration, onComplete]);

  if (!isVisible) return null;

  const getTypeStyles = () => {
    switch (type) {
      case 'success':
        return {
          background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
          icon: '✅',
          borderColor: '#059669',
          textColor: '#ffffff'
        };
      case 'error':
        return {
          background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
          icon: '❌',
          borderColor: '#dc2626',
          textColor: '#ffffff'
        };
      case 'warning':
        return {
          background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
          icon: '⚠️',
          borderColor: '#d97706',
          textColor: '#ffffff'
        };
      case 'processing':
        return {
          background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
          icon: '⏳',
          borderColor: '#2563eb',
          textColor: '#ffffff'
        };
      case 'mpesa':
        return {
          background: 'linear-gradient(135deg, #059669 0%, #047857 100%)',
          icon: '📱',
          borderColor: '#047857',
          textColor: '#ffffff'
        };
      case 'info':
      default:
        return {
          background: 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)',
          icon: 'ℹ️',
          borderColor: '#4b5563',
          textColor: '#ffffff'
        };
    }
  };

  const getPositionStyles = () => {
    switch (position) {
      case 'top':
        return { top: '20px', left: '50%', transform: 'translateX(-50%)' };
      case 'center':
        return { top: '50%', left: '50%', transform: 'translate(-50%, -50%)' };
      case 'bottom':
        return { bottom: '20px', left: '50%', transform: 'translateX(-50%)' };
      default:
        return { top: '50%', left: '50%', transform: 'translate(-50%, -50%)' };
    }
  };

  const typeStyles = getTypeStyles();
  const positionStyles = getPositionStyles();

  return (
    <div 
      className={`flash-message ${isAnimating ? 'animating' : ''}`}
      style={{
        ...positionStyles,
        background: typeStyles.background,
        borderColor: typeStyles.borderColor,
        color: typeStyles.textColor
      }}
    >
      <div className="flash-content">
        <span className="flash-icon">{typeStyles.icon}</span>
        <span className="flash-text">{message}</span>
      </div>
    </div>
  );
};

export default FlashMessage;
